const BASE_URL = process.env.BASE_PUBLIC_URL

export const IosAppLink = 'https://app.adjust.com/fz2t5yd?engagement_type=fallback_click&campaign='

const IosAppCampaignByProduct = 'pagina_deslogada_produto_ios_button'

const IosAppCampaignByBrand = 'pagina_deslogada_marca_ios_button'

export const AndroidAppLink = 'https://app.adjust.com/fz2t5yd?engagement_type=fallback_click&campaign='

const AndroidAppCampaignByProduct = 'pagina_deslogada_produto_android_button'

const AndroidAppCampaignByBrand = 'pagina_deslogada_marca_android_button'

export const NavConteudoLink = 'https://nav-conteudo.dasa.com.br/?dasa_source=nav'

const NavConteudoLinkParamsByProduct = '&dasa_medium=pagina_deslogada_produto&dasa_campaign=botao_header'

const NavConteudoLinkParamsByBrand = '&dasa_medium=pagina_deslogada_marca&dasa_campaign=botao_header'

export const InstagramDasa = 'https://www.instagram.com/nav.dasa/'

export const FacebookDasa = 'https://web.facebook.com/nav.dasa'

export const CentralDeAjuda = 'https://ajuda.nav.com.br/'

export const RedirectToCOA = `${BASE_URL}entrar?redirectTo=%2Fconsultas%2Fcoa%3Forigin%3D`

const OriginPageByProduct = 'pagina_deslogada_produto'

const OriginPageByBrand = 'pagina_deslogada_marca'

export const formatAsCurrency = (value: number, stripSymbols = false): string => {
    const options = { currency: 'BRL', ...(stripSymbols ? { minimumFractionDigits: 2 } : { style: 'currency' }) }

    return new Intl.NumberFormat('pt-BR', options).format(value)
}

const slashLength = window.location.pathname.match(/\//g)?.length
export const IsPageByBrandProduct = slashLength && slashLength > 2

export const NavConteudoLinkBuilded = IsPageByBrandProduct
    ? `${NavConteudoLink}${NavConteudoLinkParamsByProduct}`
    : `${NavConteudoLink}${NavConteudoLinkParamsByBrand}`

export const RedirectToCOABuilded = IsPageByBrandProduct
    ? `${RedirectToCOA}${OriginPageByProduct}`
    : `${RedirectToCOA}${OriginPageByBrand}`

export const IosAppLinkBuilded = IsPageByBrandProduct
    ? `${IosAppLink}${IosAppCampaignByProduct}`
    : `${IosAppLink}${IosAppCampaignByBrand}`

export const AndroidAppLinkBuilded = IsPageByBrandProduct
    ? `${AndroidAppLink}${AndroidAppCampaignByProduct}`
    : `${AndroidAppLink}${AndroidAppCampaignByBrand}`
